/** @type {import('tailwindcss').Config} */

const rem = (px) => (px ? `${(px / 10).toFixed(7)}rem` : '0rem')

module.exports = {
  important: '#exc',
  content: [
    './wordpress/wp-content/themes/wp-base-theme/**/*.{html,js,php,twig}'
  ],
  theme: {
    transitionDuration: {
      120: '120ms',
      300: '300ms',
      1300: '1300ms'
    },
    transitionDelay: {
      2000: '2s'
    },
    fontFamily: {
      sans: 'Plaax',
      serif: 'Louize Display'
    },
    fontSize: {
      8: '0.8rem',
      10: '1rem',
      11: '1.1rem',
      12: '1.2rem',
      14: '1.4rem',
      16: '1.6rem',
      18: '1.8rem',
      20: '2rem',
      22: '2.2rem',
      23: '2.3rem',
      24: '2.4rem',
      25: '2.5rem',
      30: '3rem',
      31: '3.1rem',
      32: '3.2rem',
      33: '3.3rem',
      38: '3.8rem',
      45: '4.5rem',
      48: '4.8rem',
      50: '5rem',
      65: '6.5rem',
      100: '10rem'
    },
    lineHeight: {
      83: '.83',
      92: '.92',
      100: '1',
      104: '1.04',
      110: '1.1',
      114: '1.14',
      116: '1.16',
      120: '1.2',
      140: '1.4'
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      black: {
        true: '#000',
        DEFAULT: '#1A1A1A'
      },
      white: {
        DEFAULT: '#FFFFFF'
      },
      blue: {
        DEFAULT: '#0019FF'
      },
      gray: {
        light: '#F1F1F1',
        border: '#E7E7E7',
        DEFAULT: '#DCDCDC',
        dark: '#747480'
      }
    },
    minWidth: {
      '1/5': '20%'
    },
    spacing: () => {
      const v = {
        wrapper: '24px',
        px: '1px',
        '1/2h': '50vh',
        '3/4h': '75vh',
        2: rem(2),
        3: rem(3),
        4: rem(4),
        5: rem(5),
        6: rem(6),
        8: rem(8),
        9: rem(9),
        10: rem(10),
        11: rem(11),
        12: rem(12),
        14: rem(14),
        18: rem(18),
        20: rem(20),
        22: rem(22),
        25: rem(25),
        30: rem(30),
        38: rem(38),
        46: rem(46),
        50: rem(50),
        56: rem(56),
        60: rem(60),
        75: rem(75),
        100: rem(100),
        150: rem(150),
        170: rem(170),
        210: rem(210),
        250: rem(250)
      }
      for (let i = 0; i <= 100; i++) {
        v[`${i * 4}`] = rem(i * 4)
      }
      return v
    },
    borderRadius: ({ theme }) => ({
      ...theme('spacing'),
      none: '0px'
    }),
    extend: {
      transitionTimingFunction: {
        DEFAULT: 'ease',

        'in-quad': 'cubic-bezier(0.55, 0.085, 0.68, 0.53);',
        'out-quad': 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        'in-out-quad': 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',

        'in-cubic': 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
        'out-cubic': 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        'in-out-cubic': 'cubic-bezier(0.645, 0.045, 0.355, 1)',

        'in-quart': 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
        'out-quart': 'cubic-bezier(0.165, 0.84, 0.44, 1)',
        'in-out-quart': 'cubic-bezier(0.77, 0, 0.175, 1)',

        'in-quint': 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
        'out-quint': 'cubic-bezier(0.23, 1, 0.32, 1)',
        'in-out-quint': 'cubic-bezier(0.86, 0, 0.07, 1)',

        'in-sine': 'cubic-bezier(0.47, 0, 0.745, 0.715)',
        'out-sine': 'cubic-bezier(0.39, 0.575, 0.565, 1)',
        'in-out-sine': 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

        'in-expo': 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
        'out-expo': 'cubic-bezier(0.19, 1, 0.22, 1)',
        'in-out-expo': 'cubic-bezier(1, 0, 0, 1)',

        'in-circ': 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
        'out-circ': 'cubic-bezier(0.075, 0.82, 0.165, 1)',
        'in-out-circ': 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',

        'in-back': 'cubic-bezier(0.6, 0, 0.735, 0.045)',
        'out-back': 'cubic-bezier(0.175, 0.885, 0.32, 1)',
        'in-out-back': 'cubic-bezier(0.68, 0, 0.265, 1)'
      },
      zIndex: {
        1: '1',
        2: '2',
        3: '3',
        sticky: 750,
        1000: '1000',
        cursor: 5000,
        'header-overlay': 6999,
        header: 7000,
        filters: 8000,
        highest: 9999
      },
      gridTemplateColumns: {
        24: 'repeat(24, minmax(0, 1fr))'
      },
      gridRowStart: {
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12',
        13: '13'
      }
    }
  },
  plugins: []
}
